import { FC } from "react";
import {
  ActivityType,
  activityTypeNameShort,
  getActivityTypeName,
} from "enums/ActivityType.enum";
import { twMerge } from "tailwind-merge";
import { cn } from "helpers/classNames";

interface Props {
  type: ActivityType;
  className?: string;
  count?: number;
  useTomningLabel?: boolean;
}

export const AssignmentTypeTag: FC<Props> = ({
  type,
  className,
  useTomningLabel = false,
}) => {
  switch (type) {
    case ActivityType.SixMonthsInspection:
      return (
        <span
          className={twMerge(
            "inline-flex items-center gap-x-0.5 rounded-md bg-sky-50 py-0.5 pl-1.5 pr-2 text-sm font-medium text-sky-950 ring-1 ring-inset ring-sky-600/10 sm:text-xs",
            className,
          )}
        >
          {getActivityTypeName(type)}
        </span>
      );
    case ActivityType.FiveYearInspection:
      return (
        <span
          className={twMerge(
            "inline-flex items-center gap-x-0.5 rounded-md bg-brand-50 py-0.5 pl-1.5 pr-2 text-sm font-medium text-brand-950 ring-1 ring-inset ring-brand-600/10 sm:text-xs",
            className,
          )}
        >
          {getActivityTypeName(type)}
        </span>
      );
    case ActivityType.Tomning:
      return (
        <span
          className={twMerge(
            "inline-flex items-center gap-x-0.5 rounded-md bg-stone-50 py-0.5 pl-1.5 pr-2 text-sm font-medium text-stone-950 ring-1 ring-inset ring-stone-600/10 sm:text-xs",
            className,
          )}
        >
          {useTomningLabel ? "Tömning" : getActivityTypeName(type)}
        </span>
      );
    case ActivityType.WaterMeasurementProtocol:
      return (
        <span
          className={cn(
            "inline-flex items-center gap-x-0.5 rounded-md bg-blue-50 py-0.5 pl-1.5 pr-2 text-sm font-medium text-blue-900 ring-1 ring-inset ring-blue-600/10 sm:text-xs",
            className,
          )}
        >
          {getActivityTypeName(type)}
        </span>
      );

    default:
      throw Error(`AssignmentTypeTag is missing implementation for ${type}`);
  }
};

const smallTagBaseClass =
  "inline-flex items-center gap-x-0.5 rounded-md py-0.5 px-1 text-sm sm:text-xs font-medium ring-1 ring-inset";

export const AssignmentTypeTagSmall: FC<Props> = ({
  type,
  className,
  count,
}) => (
  <span
    className={cn(
      smallTagBaseClass,
      getAssignmentTypeColorClasses(type),
      className,
    )}
  >
    {`${activityTypeNameShort(type)}${(count ?? 0) > 1 ? ` (x${count})` : ""}`}
  </span>
);

export const getAssignmentTypeColorClasses = (type: ActivityType) => {
  switch (type) {
    case ActivityType.FiveYearInspection:
      return "bg-brand-50 text-brand-950 ring-brand-600/20";
    case ActivityType.SixMonthsInspection:
      return "bg-sky-50 text-sky-950 ring-sky-600/20";
    case ActivityType.Tomning:
      return "bg-stone-50 text-stone-950 ring-stone-600/20";
    case ActivityType.WaterMeasurementProtocol:
      return "bg-blue-50 text-blue-900 ring-blue-600/10";
  }
};
